// Partner Portal host(s), from REACT_APP_PARTNER_HOSTS (comma-separated; empty
// by default). Such a host serves ONLY /partners/* (the backend fences it in
// middleware/partnerHost.js); this is the client half: where sign-in lives and
// which login screen a signed-out user is sent to.
export const PARTNER_HOSTS = String(process.env.REACT_APP_PARTNER_HOSTS || '')
  .split(',').map((h) => h.trim().toLowerCase()).filter(Boolean);
export const PARTNER_ORIGIN = PARTNER_HOSTS[0] ? `https://${PARTNER_HOSTS[0]}` : '';

export function isPartnerHost(host) {
  const h = String(host ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  return !!h && PARTNER_HOSTS.includes(h);
}

// The login screen for whoever is on this page: partners never see the staff one.
export function loginPath() {
  if (typeof window === 'undefined') return '/login';
  return isPartnerHost() || window.location.pathname.startsWith('/partners') ? '/partners/login' : '/login';
}
